import React, { useEffect, useState } from "react";
import SignDocs from "./SignDocs";
import { Button } from "antd";
// import { footerText } from "util/config";
import { Card } from "antd";
import Service from "../../service";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { showAuthLoader, hideAuthLoader } from "../../appRedux/actions/Auth";
import { GLOBAL_CONFIG } from "../../constants/permission_id";
import { useParams } from "react-router-dom";
const API_URL = `${process.env.REACT_APP_API_URL}/uploads/company_image`;

const SignedDocCandidate = () => {
    const { companyslug } = useParams();
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQuery();
  let token = query.get("token");
  // const companySlug = localStorage.getItem("companyDomain");
  const Logo = localStorage.getItem(`LogoUrl_${companyslug}`);

  const dispatch = useDispatch();
  const [empDocs, setEmpDocs] = useState([]);
  const [isSignedAnyDoc, setIsSignedAnyDoc] = useState([]);
  const [currentDoc, setCurrentDoc] = useState({ url: "" });
  const [allDocsSigned, setAllDocsSigned] = useState(false);
  const [footerText, setFooterText] = useState("");
  const [alreadySignMsg, setAlreadySignMsg] = useState(
    "All documents are submitted"
  );
  const [filename, setFilename] = useState([]);

  const [signForAllDoc, setSignForAllDoc] = useState(null);

  useEffect(() => {
    getOnboardingEmpDocs();
    setSignForAllDoc(localStorage.getItem("signatu"));
  }, []);

  useEffect(() => {
    // Extract document names directly from needToSignDocs array (dynamic documents)
    if (empDocs && empDocs.length > 0) {
      const docNames = empDocs.map((doc) => doc.doc_Type);
      setFilename(docNames);
    }

    const firstUnsignedOrUnapprovedDoc = empDocs?.find((doc) => !doc.isSigned);
    if (firstUnsignedOrUnapprovedDoc) {
      setCurrentDoc(firstUnsignedOrUnapprovedDoc);
      setAllDocsSigned(false);
    } else {
      setAllDocsSigned(true);
    }
  }, [empDocs]);

  useEffect(() => {
     const slug = companyslug;
    getCompanyData(slug).then((data) => {
      setFooterText(
        `Copyright ${data.companyName} © ${new Date().getFullYear()}`
      );
    });
  }, []);

  async function getCompanyData(slug) {
    try {
      const payload = {slug : slug}
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: `${Service.getCompanyMedia}`,
        body : payload,
      });
      return response.data.data;
    } catch (err) {
      console.error("Error fetching company:", err);
      return { companyName: "Default Company" };
    }
  }
  const getOnboardingEmpDocs = async (values) => {
    try {
      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: `${Service.getOnboardingEmpDetailsByToken}/${token}`,
      });

      if (response.data && response.data.data) {
        // Use documents directly from needToSignDocs (these are the actual documents generated)
        // No need to hardcode document names - use whatever is in the array
        setEmpDocs(response.data.data.needToSignDocs || []);
        setIsSignedAnyDoc(response.data.data.SignDocs || []);
        
        // Extract document names from the actual documents
        if (response.data.data.needToSignDocs && response.data.data.needToSignDocs.length > 0) {
          const docNames = response.data.data.needToSignDocs.map((doc) => doc.doc_Type);
          setFilename(docNames);
        } else {
          setFilename([]);
        }
      }
      if (
        Array.isArray(response.data.data) &&
        response.data.data.length === 0
      ) {
        setAlreadySignMsg("Your documents uploaded successfully !");
        dispatch(hideAuthLoader());
      }
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };

  const changeFile = (file) => {
    let doc = empDocs?.find((item) => item.doc_Type == file);
    setCurrentDoc(doc);
  };

  return (
    <div className="onboarding-candidate">
      <div className="elsner_onboarding_header">
        <div className="logo">
          <a href="/">
            {Logo ? (
              <img alt="example" src={`${API_URL}/${Logo}`} onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = GLOBAL_CONFIG.LOGO_WHITE; }} />
            ) : (
              <img alt="example" src={GLOBAL_CONFIG.LOGO_WHITE} />
            )}
          </a>
        </div>
      </div>

      {allDocsSigned ? (
        <div
          style={{
            color: "green",
            display: "flex",
            justifyContent: "center",
            fontSize: "20px",
            margin: "20px",
          }}
        >
          {alreadySignMsg}
        </div>
      ) : (
        <>
          <Card title="Documents To Be Signed By Candidate">
            <div className="signed_button">
              {filename.map((file, index) => {
                const doc = empDocs?.find((doc) => doc.doc_Type === file);
                const isApproved = doc ? doc.status === "Approve" : false;
                const isSigned = doc ? doc.isSigned : false;
                const activeStyle = {
                  backgroundColor: "#187cb7",
                  color: "white",
                };

                const inactiveStyle = {
                  backgroundColor: "transparent",
                  color: "grey",
                };
                const buttonStyle =
                  file === currentDoc?.doc_Type ? activeStyle : inactiveStyle;

                return (
                  <Button
                    style={buttonStyle}
                    disabled={isApproved || isSigned}
                    key={index}
                    onClick={() => changeFile(file)}
                  >
                    {file}
                    {isApproved || isSigned ? (
                      <CheckCircleOutlined style={{ color: "green" }} />
                    ) : null}
                  </Button>
                );
              })}
            </div>
          </Card>
          <SignDocs
            initialFile={currentDoc}
            getEmpDataFunction={getOnboardingEmpDocs}
            isSignedAnyDoc={isSignedAnyDoc}
            signForAllDoc={signForAllDoc}
          />
        </>
      )}

      <div className="elsner_onboarding_footer">
        <p>{footerText}</p>
      </div>
    </div>
  );
};

export default SignedDocCandidate;
